/**
 * Leads Page
 *
 * Displays all leads using UniversalTable component
 * Route: /apps/leads
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UniversalTable } from '@/components/features/udc/UniversalTable';

export const LeadsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleRowClick = (record: any) => {
    // Navigate to lead detail page when row is clicked
    navigate(`/apps/leads/${record.id}`);
  };

  return (
    <UniversalTable
      collection="leads"
      title="Leads"
      searchPlaceholder="Search leads..."
      onRowClick={handleRowClick}
      customRenderers={{
        // Custom renderer for lead name/title (make it stand out)
        name: (value, record) => (
          <span style={{ fontWeight: 500, color: 'var(--primary-color)' }}>
            {value}
          </span>
        ),
        // Custom renderer for company name if exists
        company: (value) => (
          <span style={{ color: 'var(--text-secondary)' }}>{value || '-'}</span>
        ),
      }}
    />
  );
};
